import { render, staticRenderFns } from "./add-advertise.vue?vue&type=template&id=6a70e439&scoped=true&"
import script from "./add-advertise.vue?vue&type=script&lang=js&"
export * from "./add-advertise.vue?vue&type=script&lang=js&"
import style0 from "./add-advertise.vue?vue&type=style&index=0&id=6a70e439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70e439",
  null
  
)

export default component.exports